import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _B0___init__impl__6otxhp3mcruxpyvxyvt as _B0___init__impl__6otxhp,
  _B0___get_b0__impl__g161pk3gu6min7plxp0 as _B0___get_b0__impl__g161pk,
} from './internal/-EndianUtils.mjs';
import { toByte4i43936u611k as toByte } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BigClass;
function Big() {
  if (BigClass === VOID) {
    class $ extends Endian() {}
    initMetadataForObject($, 'Big');
    BigClass = $;
  }
  return BigClass;
}
var LittleClass;
function Little() {
  if (LittleClass === VOID) {
    class $ extends Endian() {
      constructor() {
        Little_instance = null;
        super();
        Little_instance = this;
      }
      g3o(source, offset) {
        // Inline function 'org.kotlincrypto.bitops.endian.internal.unpackLEInt' call
        var tmp0 = _B0___init__impl__6otxhp(source[offset]);
        var tmp2 = source[offset + 1 | 0];
        var tmp4 = source[offset + 2 | 0];
        // Inline function 'org.kotlincrypto.bitops.endian.internal.toLEInt' call
        var b3 = source[offset + 3 | 0];
        return _B0___get_b0__impl__g161pk(tmp0) & 255 | (tmp2 & 255) << 8 | (tmp4 & 255) << 16 | b3 << 24;
      }
      h3o(source, dest, destOffset) {
        // Inline function 'org.kotlincrypto.bitops.endian.internal.packLEInt' call
        dest[destOffset] = toByte(source);
        dest[destOffset + 1 | 0] = toByte(source >>> 8 | 0);
        dest[destOffset + 2 | 0] = toByte(source >>> 16 | 0);
        dest[destOffset + 3 | 0] = toByte(source >>> 24 | 0);
        return dest;
      }
      i3o(source, dest, destOffset, sourceIndexStart, sourceIndexEnd) {
        // Inline function 'org.kotlincrypto.bitops.endian.internal.packArray' call
        var destPos = destOffset;
        var sourcePos = sourceIndexStart;
        while (sourcePos < sourceIndexEnd) {
          var tmp0 = sourcePos;
          sourcePos = tmp0 + 1 | 0;
          var destPos_0 = destPos;
          // Inline function 'org.kotlincrypto.bitops.endian.internal.packLEInt' call
          var source_0 = source[tmp0];
          dest[destPos_0] = toByte(source_0);
          dest[destPos_0 + 1 | 0] = toByte(source_0 >>> 8 | 0);
          dest[destPos_0 + 2 | 0] = toByte(source_0 >>> 16 | 0);
          dest[destPos_0 + 3 | 0] = toByte(source_0 >>> 24 | 0);
          destPos = destPos + 4 | 0;
        }
        return dest;
      }
      equals(other) {
        return other instanceof Little();
      }
      hashCode() {
        return 527 + getKClass(Little()).hashCode() | 0;
      }
    }
    initMetadataForObject($, 'Little');
    LittleClass = $;
  }
  return LittleClass;
}
var Little_instance;
function Little_getInstance() {
  if (Little_instance === VOID)
    new (Little())();
  return Little_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var EndianClass;
function Endian() {
  if (EndianClass === VOID) {
    class $ {
      toString() {
        var tmp;
        if (this instanceof Big()) {
          tmp = 'Endian.Big';
        } else {
          if (this instanceof Little()) {
            tmp = 'Endian.Little';
          } else {
            noWhenBranchMatchedException();
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Endian');
    EndianClass = $;
  }
  return EndianClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Little_getInstance as Little_getInstance3o64tamm9djeo,
};
//endregion

//# sourceMappingURL=Endian.mjs.map
